import { decodeUtf8 } from "base/backbone/lib/utilities/helpers";

Pixlee.module('UploaderV3App.Show', function(Show, App, Backbone, Marionette, $) {
    Show.preventClosing = {
        uploaderCollection: null
    };
    Show.Layout = App.Views.Layout.extend({
        template: require('./templates/layout.jst.ejs'),
        className: 'wrap',
        id: 'uploader_widget',
        regions: {
            mainContent: '#content_holder',
            uploadHolder: '#upload_holder',
            extraContent: '#info_holder'
        },
        ui: {
            alert: '.alert',
            alertFormat: '#alert_format',
            breadcrumbsContainer: '#breadcrumbs_container',
            breadcrumbsHiddenTitle: '#breadcrumbs_hidden_title',
            breadcrumb: '.breadcrumb',
            closeButton: '#close',
            fileAlert: '#file_alert',
            mainContent: '#content_holder',
            outsideUploader: '#uploader_overlay',
            uploaderFrame: '#uploader_frame',
            uploaderAlert: '#uploader_alert',
            uploaderBackAlert: '#uploader_back_alert',
            uploaderError: '#uploader_error',
            uploaderErrorButton: '#uploader_error_button',
            topBar: '#top_bar',
            pickSource: '#pick_source',
            selectContent: '#select_content',
            reviewSubmission: '#review_submission',
            submitContent: '#submit_content',
            noCloseUploader: '#no',
            noAlertBack: '#alert_back_no',
            yesCloseUploader: '#yes',
            yesAlertBack: '#alert_back_yes',
            yesFile: '#yes_file'
        },
        events: {
            'click @ui.yesFile': 'onHideAlert',
            'click @ui.noCloseUploader': 'onHideAlert',
            'click @ui.noAlertBack': 'onHideAlert',
            'click @ui.uploaderErrorButton': 'onHideAlert',
            'click @ui.yesCloseUploader': 'closeParentIFrame',
            'click @ui.yesAlertBack': 'goBackUploaderBackAlert',
            'click @ui.pickSource': 'checkPickSource',
            'click @ui.selectContent': 'checkSelectContent',
            'click @ui.reviewSubmission': 'showReviewSubmission',
            'click @ui.submitContent': 'showSubmitContent',
            'click @ui.closeButton': 'onBeforeCloseUploader',
            'click @ui.outsideUploader': 'onBeforeCloseUploader',
            'keydown': 'handleKeyboard'
        },
        initialize: function() {
            this.lastActiveElement = null;

            /* Specifiying the list of focusable elements is important for trapping keyboard focus in a modal popup.
             * Uploader elements and alert elements are stored in separate properties because
             * when an alert becomes active we also need to give uploader elements a tabindex of -1 in order to hide them from screen readers.
             */

            // for uploader contents
            this.focusableElements = [];
            this.activeFocusIndex = 0;

            // for alert box contents
            this.alertFocusableElements = [];
            this.activeAlertFocusIndex = 0;
        },
        onShow: function() {
            this.trigger('keen:opened:uploader');
        },
        closeUploader: function() {
            var msg = {
                name: 'pixlee:close:uploader',
                type: 'action',
                source: 'uploader',
                destination: 'parent',
                data: {}
            };

            window.parent.postMessage(JSON.stringify(msg), '*');
        },
        handleKeyboard: function(e) {
            var alertIsActive = this.ui.alert.hasClass('active');

            this.mapKeyboardInteractionToElements(e);

            switch (e.key) {
                case 'Enter':
                    /* ENTER */
                    // find the last active element before alert appears
                    if (_.isFalsy(alertIsActive) && this.focusableElements.indexOf(e.target) > -1) {
                        this.lastActiveIndex = this.focusableElements.indexOf(e.target);
                    }

                    // do not allow breadcrumb buttons to lose focus when being selected
                    if (e.target.classList.contains('breadcrumb') && e.target.getAttribute('role') === 'button') {
                        $(e.target).focus();
                    }

                    break;
                case 'Tab':
                    /* TAB ---
                     * In order to trap tab focus in modal, we check if the current item is part of our indexed focusable elements;
                     * 1) if user tabs (forward) to the last indexed element, next element is the first of index
                     * 2) if user presses shift + tab (backwards) and reaches first indexed element, next element is last element of index
                     */

                    if (this.focusableElements.indexOf(e.target) > -1) {
                        this.activeFocusIndex = this.focusableElements.indexOf(e.target);
                        this.cycleTab(e, this.focusableElements, this.activeFocusIndex);
                    }

                    // alert box
                    if (_.isTruthy(alertIsActive)) {
                        if (this.alertFocusableElements.indexOf(e.target) > -1) {
                            this.activeAlertFocusIndex = this.alertFocusableElements.indexOf(e.target);
                            this.cycleTab(e, this.alertFocusableElements, this.activeAlertFocusIndex);
                        } else {
                            // this catches when onShowAlert is triggered from another view; we need to set focus of the first indexed element
                            e.preventDefault();
                            this.alertFocusableElements[0].focus();
                        }
                    }
                    break;
                case 'Esc':
                case 'Escape':
                    /* ESC ---
                     * A user should be able to close a modal using the esc key on a keyboard;
                     * 1) if user opens uploader, does not select any photos to upload, hits esc; uploader will close
                     * 2) if user opens uploader, selects some photos without submitting, hits esc; alert prompt appears
                     * 3) if alert prompt is active and photos are not selected, user hits esc key; just close alert prompt
                     * 4) if alert prompt is active, user hits esc key, alert assumes "no" and closes
                     */

                    this.onBeforeCloseUploader(e);
                    break;
                default:
                    break;
            }
        },
        // when user clicks on X or outside of uploader
        onBeforeCloseUploader: function(e) {
            const isOnLastPage = this.ui.mainContent.has('#panel_confirmation').length > 0;
            if (isOnLastPage) { // photos already submitted, can just close safely
                return this.closeParentIFrame();
            }

            const alertIsActive = this.ui.alert.hasClass('active');
            const photosSelected = Show.preventClosing.uploaderCollection;

            // find the last active element before alert appears
            if (_.isFalsy(alertIsActive) && this.focusableElements.indexOf(e.target) > -1) {
                const lastActiveIndex = this.focusableElements.indexOf(e.target);
                this.lastActiveElement = this.focusableElements[lastActiveIndex];
            }
            // if no photos are selected or we are in the confirm panel, failed submission panel, or first panel
            if (!photosSelected) {
                if (_.isTruthy(alertIsActive)) {
                    this.onHideAlert();
                } else {
                    this.closeParentIFrame();
                }
            } else {
                // if there are photos selected and we're not explicitly stopping the alert from appearing
                this.onGetFocusIndex(this.ui.uploaderAlert, true);
                this.setTabindexOfElements(this.focusableElements, '-1');
                this.ui.uploaderAlert.toggleClass('active');

                if (_.isTruthy(alertIsActive)) {
                    this.onHideAlert();
                } else {
                    e.preventDefault(); // prevents clicking "no" right away
                    this.ui.noCloseUploader.focus();
                }
            }
        },
        // Creates an index of focusable elements for keyboard accessibility
        onGetFocusIndex: function(el, isAlert) {
            if (_.isTruthy(isAlert)) {
                // create focus index for alert prompts
                this.alertFocusableElements = this.createFocusIndex([el]);
            } else {
                /* Create a focus index for the panel passed to this function (e.g. extraContent panel),
                 * otherwise create an index for the main content
                 */
                var panel = _.isTruthy(el) ? el : this.mainContent.$el;

                /* A focus index for the uploader includes the:
                 * 1) the breadcrumb top bar
                 * 2) current panel (e.g. home, select content, review, info panel)
                 */
                this.focusableElements = this.createFocusIndex([this.ui.topBar, panel]);
            }
        },
        goBackUploaderBackAlert: function() {
            if (this.ui.uploaderBackAlert.hasClass('two')) {
                this.trigger('show:select:content');
            } else {
                this.trigger('show:home:view');
            }
            this.onHideAlert();
        },
        checkSelectContent: function() {
            var targetClass = this.ui.breadcrumbsContainer.find('.active').attr('class');
            var currentStepNumber = targetClass.match(/one|two|three|four/g)[0];
            this.trigger('keen:clicked:navigation', 'Select Content', currentStepNumber);
            this.trigger('check:select:content');
        },
        checkPickSource: function() {
            var targetClass = this.ui.breadcrumbsContainer.find('.active').attr('class');
            var currentStepNumber = targetClass.match(/one|two|three|four/g)[0];
            this.trigger('keen:clicked:navigation', 'Choose Source', currentStepNumber);
            this.trigger('check:pick:source');
        },
        showSelectContent: function() {
            this.trigger('show:select:content');
        },
        showReviewSubmission: function() {
            var targetClass = this.ui.breadcrumbsContainer.find('.active').attr('class');
            var currentStepNumber = targetClass.match(/one|two|three|four/g)[0];
            this.trigger('keen:clicked:navigation', 'Review Submission', currentStepNumber);
            this.trigger('show:review:submission');
        },
        showSubmitContent: function() {
            var targetClass = this.ui.breadcrumbsContainer.find('.active').attr('class');
            var currentStepNumber = targetClass.match(/one|two|three|four/g)[0];
            this.trigger('keen:clicked:navigation', 'Submit Content', currentStepNumber);
            this.trigger('show:submit:content');
        },
        /* This method should be used for triggering an alert prompt from another part of the view;
         * Pass the id of the alert prompt and additional data object;
         * e.g. there are different types of file upload alerts so we pass the alert id (file_alert)
         * and any data-attribute data to dislpay
         */
        onShowAlert: function(alertPrompt, data) {
            alertPrompt.addClass('active');
            this.onGetFocusIndex(alertPrompt, true);
            this.setTabindexOfElements(this.focusableElements, '-1');

            if (data.error_type) {
                alertPrompt.find('#' + data.error_type).addClass('active');
            }

            if (data.alert_format) {
                this.ui.alertFormat.text(data.alert_format);
            }
        },
        onHideAlert: function() {
            this.ui.alert.find('.active').removeClass('active');
            this.ui.alert.removeClass('active');
            // resume focus on elements
            this.setTabindexOfElements(this.focusableElements, '0');

            // if there is no last active element specified, return to the first element in index
            if (_.isTruthy(this.lastActiveElement)) {
                this.lastActiveElement.focus();
            } else {
                this.focusableElements[0].focus();
            }
        },
        onShowMainContent: function() {
            if (_.isTruthy(this.mainContent.$el)) {
                this.mainContent.$el.show();
            }
        },
        onShowUploadHolder: function() {
            if (_.isTruthy(this.uploadHolder.$el)) {
                this.uploadHolder.$el.show();
            }
        },
        onHideMainContent: function() {
            if (_.isTruthy(this.mainContent.$el)) {
                this.mainContent.$el.hide();
            }
        },
        onHideUploadHolder: function() {
            if (_.isTruthy(this.uploadHolder.$el)) {
                this.uploadHolder.$el.hide();
            }
        },
        onShowUploaderBackAlert: function(step) {
            this.onGetFocusIndex(this.ui.uploaderBackAlert, true);
            this.setTabindexOfElements(this.focusableElements, '-1');
            this.ui.uploaderBackAlert.addClass('active', step);
            this.ui.noAlertBack.focus();
        },
        onUpdateBreadcrumb: function(step, backwards) {
            var furthestStep = this.ui.breadcrumbsContainer.attr('class');
            var currStep = step;
            var furthestStepInt = this.mapStep(furthestStep);
            var currStepInt = this.mapStep(currStep);

            // If the uploader has just been opened (the first step is the only active step)
            var uploaderFirstLoad = currStepInt === 1 && furthestStepInt === 1;

            // update current step header for screen readers and structure
            var stepString = this.ui.breadcrumbsContainer.find('.breadcrumb.' + currStep + ' .text').text();
            this.ui.breadcrumbsHiddenTitle.text(stepString);

            this.focusOnBreadcrumb(uploaderFirstLoad);

            if (step === 'hide') {
                this.ui.topBar.addClass('hidden');
            } else if (step === 'disabled') {
                this.ui.breadcrumbsContainer.addClass('disabled');
            } else if (backwards || currStepInt > furthestStepInt) {
                this.ui.breadcrumbsContainer.removeClass();
                this.ui.breadcrumbsContainer.addClass(step);
            }
        },
        focusOnBreadcrumb: function(uploaderFirstLoad) {
            // If the uploader has just been opened, focus on the close button
            if (uploaderFirstLoad) {
                this.ui.closeButton.focus();
            } else {
                this.ui.breadcrumbsContainer.find('.active').focus();
            }
        },
        mapStep: function(step) {
            // BREADCRUMBS: steps 1, 2, 3, 4
            // Only add tabindex (focusable items) for the ones that are active and that are clickable
            // aria-current is used to represent the current step within a process
            var num = 0;
            var tabElem;

            this.ui.breadcrumbsContainer.children().removeClass('active').removeAttr('tabindex aria-current');
            switch (step) {
                case 'one':
                    num = 1;
                    tabElem = this.ui.pickSource;
                    break;
                case 'two':
                    num = 2;
                    tabElem = this.ui.selectContent;
                    break;
                case 'three':
                    num = 3;
                    tabElem = this.ui.reviewSubmission;
                    break;
                case 'four':
                    num = 4;
                    tabElem = this.ui.submitContent;
                    break;
                default:
                    break;
            }

            // highlight corresponding breadcrumb
            if (_.isTruthy(tabElem)) {
                tabElem.addClass('active').attr({
                    'tabindex': '0',
                    'aria-current': 'step'
                });
            }
            if (num > 1) {
                this.ui.pickSource.attr('tabindex', '0');
            }
            if (num > 2) {
                this.ui.selectContent.attr('tabindex', '0');
            }
            if (num > 3) {
                this.ui.reviewSubmission.attr('tabindex', '0');
            }

            return num;
        },
        closeParentIFrame: function() {
            var targetClass = this.ui.breadcrumbsContainer.find('.active').attr('class');
            var currentStepNumber = targetClass ? targetClass.match(/one|two|three|four/g)[0] : 'four';
            this.trigger('keen:canceled:submission', currentStepNumber);

            this.closeUploader();
        },
        templateHelpers: function() {
            var albumType = this.options.currentAlbum && this.options.currentAlbum.album_type ? this.options.currentAlbum.album_type : '';
            return {
                albumType: albumType
            };
        }
    });
    Show.Layout.include(['AccessibilityHelpers']);

    Show.Home = App.Views.ItemView.extend({
        template: require('./templates/home_panel.jst.ejs'),
        id: 'panel_home',
        className: 'panel',
        triggers: {
            'click #source_desktop': 'show:desktop:drag:drop',
            'click #info_button': 'show:info'
        },
        ui: {
            instagram: '#source_instagram',
            facebook: '#source_facebook',
            googlePhotos: '#source_google_photos'
        },
        events: {
            'click @ui.instagram': 'instagramLogin',
            'click @ui.facebook': 'facebookLogin',
            'click @ui.googlePhotos': 'googlePhotosLogin'
        },
        onShow: function() {
            this.trigger('update:breadcrumb', 'one', true);
            // create index of focusable elements for keyboard/screen reader users
            this.trigger('get:focus:index', this.$el);
        },
        instagramLogin: function() {
            var _this = this;
            App.execute('instagram:login:photos', function(socialLogin) {
                _this.trigger('show:instagram', socialLogin);
            });
        },
        facebookLogin: function() {
            var _this = this;
            App.execute('facebook:login:photos', function(socialLogin) {
                _this.trigger('show:facebook', socialLogin);
            });
        },
        googlePhotosLogin: function() {
            var _this = this;
            App.execute('google:login:photos', function(socialLogin) {
                _this.trigger('show:gphotos', socialLogin);
            });
        },
        templateHelpers: {
            infoButton: function() {
                return gon.display_options.infoButton;
            }
        }
    });

    Show.ConfirmPanel = App.Views.ItemView.extend({
        template: require('../shared/confirm.jst.ejs'),
        id: 'panel_confirmation',
        className: 'panel',
        ui: {
            'finish': '#finish',
            'confirmButton': '.confirm_button'
        },
        events: {
            'click @ui.finish': 'closeParentIFrame'
        },
        onShow: function() {
            this.trigger('update:breadcrumb', 'hide');

            // create index of focussable elements for keyboard/screen reader users
            this.trigger('get:focus:index', this.$el);

            // focus on bottom button when panel first appears
            this.ui.confirmButton.focus();
        },
        closeParentIFrame: function() {
            if ('parentIFrame' in window) {
                window.parentIFrame.close();
            }
        },
        templateHelpers: function() {
            return {
                redirect_url: gon.display_options.thankYouUrl_input
            };
        }
    });

    Show.DragDrop = App.Views.Layout.extend({
        template: require('./templates/drag_drop_panel.jst.ejs'),
        id: 'panel_drag_drop',
        className: 'panel',
        ui: {
            'fileuploader': '#fileuploader',
            'fileInput': '#file_input',
            'dragDropTitle': '#drag_drop_form',
            'dragDropContainer': '#drag_drop_container'
        },
        events: {
            'click @ui.fileuploader': 'getFile',
            'onchange @ui.fileInput': 'sub'
        },
        initialize: function(options) {
            this.connectedUser = options.connectedUser;
            this.contentCount = 0;
        },
        onShow: function() {
            this.create();
            this.trigger('update:breadcrumb', 'two', true);

            // create index of focusable elements for keyboard/screen reader users
            this.trigger('get:focus:index', this.$el);
            this.navigationWarning = function(e) {
                // If we haven't been passed the event get the window.event
                //_this.ui.uploaderAlert.show();
                e = e || window.event;
                var message = 'Upload has not finished!';
                // For IE6-8 and Firefox prior to version 4
                if (e) {
                    e.returnValue = message;
                }
                // For Chrome, Safari, IE8+ and Opera 12+
                return message;
            };
        },
        getFile: function(e) {
            // prevent button from automatically submitting form
            e.preventDefault();
            this.ui.fileInput.click();
        },
        create: function() {
            var config = App.config.toJSON();
            var _this = this;
            // An array of album photo ids to send in the final event when 'show:confirm:panel' is triggered;
            this.uploadedAlbumPhotoIds = [];
            this.ui.dragDropTitle.fileupload({
                dataType: 'text',
                autoUpload: true,
                url: config.s3_bucket_url,
                acceptFileTypes: /(\.|\/)(mp4|mov|m4v|jpe?g|png|gif)$/i,
                maxFileSize: 300000000,
                maxNumberOfFiles: 20,
                previewMaxWidth: 133,
                previewMaxHeight: 133,
                start: function() {
                    App.execute('show:uploader:loader');
                },
                add: function(e, data) {
                    //I think there's some issue with the inclusion of external plugins for the library
                    //just do the checks manually for now
                    //http://stackoverflow.com/questions/17451629/maxfilesize-and-acceptfiletypes-in-blueimp-file-upload-plugin-do-not-work-why
                    if (_this.collection.length >= 20) {
                        _this.trigger('show:alert', $('#file_alert'), {
                            error_type: 'file_amount'
                        });
                        $('#yes_file').click(function() {
                            $(_this.ui.dragDropContainer).hide();
                            _this.trigger('show:review:panel', 'desktop');
                        });
                        return false;
                    }
                    if (data.files[0].size > 300000000) {
                        _this.trigger('show:alert', $('#file_alert'), {
                            error_type: 'file_size'
                        });
                        if (!_this.collection.length) {
                            _this.trigger('reset:view');
                        }
                        return false;
                    }
                    if (!data.files[0].name.match(/(\.|\/)(mp4|mov|m4v|jpe?g|png|gif)$/i)) {
                        var fileFormat = data.files[0].name.split('.');
                        _this.trigger('show:alert', $('#file_alert'), {
                            error_type: 'file_type',
                            alert_format: fileFormat[fileFormat.length - 1]
                        });
                        if (!_this.collection.length) {
                            _this.trigger('reset:view');
                        }
                        return false;
                    }
                    var model = new App.Entities.Model(data);
                    model.set('originalFile', data.originalFiles[0]);
                    model.set('uid', _this.collection.length);
                    if (data.files && data.files[0]) {
                        if (window.URL) {
                            var blob = window.URL.createObjectURL(data.files[0]);
                            model.set('dataUrl', blob);
                            _this.collection.add(model);
                        } else {
                            var reader = new FileReader();
                            reader.onload = function() {
                                model.set('dataUrl', reader.result);
                                _this.collection.add(model);
                            };
                            reader.readAsDataURL(data.files[0]);
                        }
                    }
                    _this.contentCount = _this.collection.length;
                    _this.ui.dragDropContainer.hide();
                    Show.preventClosing.uploaderCollection = _this.contentCount;

                    // show review panel
                    _this.trigger('show:review:panel', 'desktop');
                    window.onbeforeunload = _this.navigationWarning;
                }
            });
        },
        sub: function(obj) {
            var file = obj.value;
            var fileName = file.split('\\');
            this.ui.fileuploader.html(fileName[fileName.length - 1]);
            this.ui.dragDropTitle.submit();
        }
    });

    Show.ReviewPanelProductItem = App.Views.ItemView.extend({
        template: require('./templates/review_panel_product_item.jst.ejs'),
        className: 'review_panel_product_item',
        ui: {
            removeButton: '.remove_product_button'
        },
        triggers: {
            'click @ui.removeButton': 'remove:product:from:photo'
        },
        templateHelpers: function() {
            const productPhoto = decodeUtf8(this.model.get('product_photo_thumb') || this.model.get('product_photo'));

            if (gon.current_account.uploader_product_search_mode === 'tag,product') {
                return {
                    src: productPhoto,
                    alt: decodeUtf8(this.model.get('title')),
                    tag: this.model.tagName,
                };
            } else {
                return {
                    src: productPhoto,
                    alt: decodeUtf8(this.model.get('name')),
                };
            }
        }
    });

    Show.ReviewPanelItem = App.Views.CompositeView.extend({
        template: require('./templates/review_panel_item.jst.ejs'),
        className: 'photo_item_review',
        ui: {
            captionText: '.caption',
            deleteContent: '.delete_content',
            productField: '.product_field',
            productTagButton: '.product_tag_button'
        },
        childView: Show.ReviewPanelProductItem,
        childViewContainer: '.product_list',
        childEvents: {
            'remove:product:from:photo': function(view) {
                this.collection.remove(view.model);
                this.render();
            }
        },
        events: {
            'change @ui.captionText': 'changeCaption',
            'change @ui.productField': 'changeProductField'
        },
        triggers: {
            'click @ui.deleteContent': 'remove:content',
            'click @ui.productTagButton': 'show:product:search',
            'click @ui.deleteContent': 'delete:upload'
        },
        initialize: function(options) {
            this.source = options.source;
            if (!options.model.has('products')) {
                options.model.set('products', new Backbone.Collection());
            }
            this.collection = options.model.get('products');
        },
        onShow: function() {
            this.triggerMethod('update:breadcrumb', 'three');
            if (this.model.get('type') === 'video') {
                this.$el.addClass('content_video');
            } else {
                this.$el.addClass('content_image');
            }
        },
        changeCaption: function() {
            this.model.set('caption', this.ui.captionText.val().trim());
        },
        changeProductField: function() {
            this.model.set('uploader_product_input', this.ui.productField.val().trim());
        },
        templateHelpers: function() {
            return _.extend(App.request('concern', 'PhotoHelpers'), {
                isVid: function() {
                    return this.files && this.files[0].type.indexOf('video') !== -1;
                },

                getUniqueId: function() {
                    return 'file_' + this.uid;
                },

                thumbnailUrl: function() {
                    return this.dataUrl || this.picture || this.baseUrl;
                },

                hasProducts: this.model.has('products') && !this.model.get('products').isEmpty(),
                searchMode: gon.current_account.uploader_product_search_mode
            });
        }
    });

    Show.ReviewPanel = App.Views.CompositeView.extend({
        template: require('./templates/review_panel.jst.ejs'),
        behaviors: {
            UploadContentValidation: {}
        },
        childView: Show.ReviewPanelItem,
        childViewOptions: function() { return { source: this.source }; },
        childViewContainer: '#social_review_wrapper',
        id: 'panel_review',
        className: 'panel',
        childEvents: {
            'update:breadcrumb': 'onChildUpdateBreadcrumb',
            'delete:upload': 'onChildDeleteUpload',
            'show:product:search': 'onShowProductSearch',
            'show:select:content': 'onShowSelectContent',
            'remove:content': 'onRemoveContent'
        },
        initialize: function(options) {
            this.source = options.source;
            this.connectedUser = Show.connectedUser;
        },
        onShow: function() {
            // create index of focussable elements for keyboard/screen reader users
            this.trigger('get:focus:index', this.$el);
        },
        onShowSubmitContentPanel: function() {
            Show.connectedUser.set('uniqueID', gon.distinct_user_hash);
            this.trigger('show:submit:content');
        },
        onShowProductSearch: function(childView) {
            this.trigger('show:product:search', childView.model, childView.source);
        },
        onRemoveContent: function(view) {
            this.collection.remove(view.model);
        },
        onRemoveChild: function(view) {
            if (this.collection.length <= 0) {
                App.execute('hide:uploader:loader');
                if (view.model.get('confirming')) {
                    this.trigger('show:confirm:panel');
                } else {
                    this.trigger('update:breadcrumb', 'two', true);
                    this.trigger('show:select:content');
                }
            }
        },
        onChildDeleteUpload: function(_childView, params) {
            this.collection.remove(params.model);
            if (!this.collection.length) {
                this.trigger('update:breadcrumb', 'two', true);
            }
        },
        onChildUpdateBreadcrumb: function(childView, step, backwards) {
            this.trigger('update:breadcrumb', step, backwards);
        },
        onShowSelectContent: function() {
            this.trigger('show:select:content');
        },
        templateHelpers: function() {
            return {
                showSearchDescription: gon.current_account.uploader_product_search_mode !== 'hidden'
            };
        }
    });

    Show.ProductSearchRow = App.Views.ItemView.extend({
        template: require('./templates/product_search_row.jst.ejs'),
        tagName: 'li',
        className: 'product_search_row',
        attributes: {
            role: 'button',
            tabindex: 0
        },
        triggers: {
            'click': 'product:row:clicked'
        },
        initialize: function(opts) {
            this.searchModel = opts.searchModel;
            this.listenTo(this.searchModel, 'change', this.render);
        },
        bolden: function(str, term) {
            if (term === '') {
                return _.escape(str);
            }
            var escapedStr = _.escape(str);
            var regex = new RegExp(_.escape(term), 'gi');
            return escapedStr.replaceAll(regex, '<b>$&</b>');
        },
        templateHelpers: function() {
            const productPhoto = decodeUtf8(this.model.get('product_photo_thumb') || this.model.get('product_photo'));

            if (gon.current_account.uploader_product_search_mode === 'tag,product') {
                return {
                    boldProductName: this.bolden(
                        decodeUtf8(this.model.get('title')),
                        this.searchModel.get('search_term')
                    ),
                    alt: decodeUtf8(this.model.get('title')),
                    src: productPhoto
                };
            } else {
                return {
                    boldProductName: this.bolden(
                        decodeUtf8(this.model.get('name')),
                        this.searchModel.get('search_term')
                    ),
                    alt: decodeUtf8(this.model.get('name')),
                    src: productPhoto
                };
            }
        }
    });

    Show.ProductSearchEmptyView = App.Views.ItemView.extend({
        template: require('./templates/product_search_empty.jst.ejs'),
        className: 'product_search_empty'
    });
    Show.ProductSearchNoResultsView = App.Views.ItemView.extend({
        template: require('./templates/product_search_no_results.jst.ejs'),
        className: 'product_search_no_results'
    });
    Show.ProductSearchLoadingView = App.Views.ItemView.extend({
        template: require('./templates/product_search_loading.jst.ejs'),
        className: 'product_search_loading'
    });

    Show.ProductSearch = App.Views.Layout.extend({
        template: require('./templates/product_search.jst.ejs'),
        id: 'product_search',
        childEvents: {
            'product:row:clicked': function(_collectionView, model) {
                this.triggerMethod('product:row:clicked', model);
            }
        },
        regions: {
            productSearchContainer: '.product_search_results_container'
        },
        ui: {
            productSearchField: '#product_search_field',
            productSearchClearButton: '.product_search_clear',
            doneTaggingButton: '.product_search_done_tagging_button'
        },
        events: {
            'input @ui.productSearchField': function(ev) {
                this.searchModel.set('search_term', ev.target.value);
            },
            'click @ui.productSearchClearButton': function() {
                this.searchModel.set('search_term', '');
                this.ui.productSearchField.val('');
            },
            'click @ui.doneTaggingButton': function() {
                var collectionView = this.getRegion('productSearchContainer').currentView;
                if (!collectionView) {
                    return;
                }
                var selectedModel = collectionView.selectedModel;
                this.triggerMethod('done:tagging', selectedModel);
            }
        },
        initialize: function(opts) {
            this.searchModel = opts.searchModel;
        },
        onAttach: function() {
            this.getRegion('productSearchContainer').show(new Show.ProductSearchCollectionView({
                collection: this.collection,
                searchModel: this.searchModel
            }));
        },
        templateHelpers: function() {
            return {
                search_term: this.searchModel.get('search_term') || ''
            };
        }
    });

    Show.ProductSearchCollectionView = App.Views.CollectionView.extend({
        tagName: 'ul',
        className: 'product_search_results',
        childView: Show.ProductSearchRow,
        childEvents: {
            'product:row:clicked': function(view) {
                this.triggerMethod('product:row:clicked', view.model);
            }
        },
        collectionEvents: {
            'request sync error reset': 'render'
        },
        getEmptyView: function() {
            if (this.collection.loading) {
                return Show.ProductSearchLoadingView;
            }
            if (this.searchModel.get('search_term') === '') {
                return Show.ProductSearchEmptyView;
            } else {
                return Show.ProductSearchNoResultsView;
            }
        },
        childViewOptions: function() {
            return {
                searchModel: this.searchModel
            };
        },
        initialize: function(opts) {
            this.searchModel = opts.searchModel;
        }
    });

    Show.ProductSearchSubcategoryRow = App.Views.ItemView.extend({
        template: require('./templates/product_subcategory_row.jst.ejs'),
        tagName: 'li',
        className: 'product_search_subcategory_row',
        attributes: {
            role: 'button',
            tabindex: 0
        },
        triggers: {
            'click': 'subcategory:row:clicked'
        },
        initialize: function(opts) {
            this.searchModel = opts.searchModel;
            this.listenTo(this.searchModel, 'change', this.render);
        },
        select: function() {
            this.$el.toggleClass('selected', true);
        },
        unselect: function() {
            this.$el.toggleClass('selected', false);
        },
        bolden: function(str, term) {
            if (term === '') {
                return _.escape(str);
            }
            var escapedStr = _.escape(str);
            var regex = new RegExp(_.escape(term), 'gi');
            return escapedStr.replaceAll(regex, '<b>$&</b>');
        },
        templateHelpers: function() {
            return {
                src: decodeUtf8(this.model.get('product_photo_thumb') || this.model.get('product_photo')),
                name: this.bolden(decodeUtf8(this.model.get('name')), this.searchModel.get('search_term')),
                alt: decodeUtf8(this.model.get('name'))
            };
        }
    });

    Show.ProductSearchSubcategoryPicker = App.Views.Layout.extend({
        template: require('./templates/product_subcategory_picker.jst.ejs'),
        id: 'product_search',
        childView: Show.ProductSearchSubcategoryRow,
        regions: {
            productSearchContainer: '.product_search_results_container'
        },
        ui: {
            productSearchField: '#product_search_field',
            productSearchClearButton: '.product_search_clear',
            doneTaggingButton: '.product_search_done_tagging_button'
        },
        triggers: {
            'subcategory:row:clicked': 'subcategory:row:clicked'
        },
        events: {
            'input @ui.productSearchField': function(ev) {
                this.searchModel.set('search_term', ev.target.value);
            },
            'click @ui.productSearchClearButton': function() {
                this.searchModel.set('search_term', '');
                this.ui.productSearchField.val('');
            },
            'click @ui.doneTaggingButton': function() {
                var collectionView = this.getRegion('productSearchContainer').currentView;
                if (!collectionView) {
                    return;
                }
                var selectedModel = collectionView.selectedModel;
                this.triggerMethod('done:tagging', selectedModel);
            }
        },
        initialize: function(opts) {
            this.selectedModel = null; // will be selected when a row is picked

            this.collection = new Pixlee.Entities.Products([], {
                category_album_id: opts.model.id
            });
            this.searchModel = this.collection.searchModel;
            this.collection.fetch();
        },
        onAttach: function() {
            this.showChildView('productSearchContainer', new Show.ProductSearchSubcategoryPickerCollectionView({
                collection: this.collection,
                searchModel: this.searchModel
            }));
        },
        templateHelpers: function() {
            return {
                search_term: this.searchModel.get('search_term') || '',
                product_photo: decodeUtf8(this.model.get('product_photo_thumb') || this.model.get('product_photo'))
            };
        }
    });

    Show.ProductSearchSubcategoryPickerCollectionView = App.Views.CollectionView.extend({
        tagName: 'ul',
        childView: Show.ProductSearchSubcategoryRow,
        childEvents: {
            'subcategory:row:clicked': function(view) {
                this.selectedModel = view.model;
                var selectedModelId = this.selectedModel.id;
                this.children.each(function(childView) {
                    if (childView.model.id === selectedModelId) {
                        childView.select();
                    } else {
                        childView.unselect();
                    }
                });
            }
        },
        collectionEvents: {
            'request sync error': 'render'
        },
        getEmptyView: function() {
            if (this.collection.loading) {
                return Show.ProductSearchLoadingView;
            }
            if (this.searchModel.get('search_term') !== '') {
                return Show.ProductSearchNoResultsView;
            }
        },
        emptyViewOptions: {
            subcategory: true
        },
        childViewOptions: function() {
            return {
                searchModel: this.searchModel
            };
        },
        initialize: function(opts) {
            this.searchModel = opts.searchModel;
        }
    });

    Show.ProductSearchPanel = App.Views.Layout.extend({
        template: require('./templates/product_search_panel.jst.ejs'),
        id: 'product_search_panel',
        className: 'product_search panel',
        regions: {
            productSearchContainer: '.product_search_container'
        },
        childEvents: {
            'product:row:clicked': 'onProductRowClicked',
            'done:tagging': 'doneTagging'
        },
        ui: {
            backButton: '.product_search_back_button',
            cancelButton: '.product_search_cancel_button',
            doneTaggingButton: '.product_search_done_tagging_button'
        },
        events: {
            'click @ui.backButton': 'showProductSearch',
            'click @ui.cancelButton': 'showReviewPanel'
        },
        initialize: function(options) {
            this.source = options.source;
            if (gon.current_account.uploader_product_search_mode === 'tag,product') {
                this.collection = new Pixlee.Entities.Tags();
            } else {
                this.collection = new Pixlee.Entities.Products();
            }
            this.searchModel = this.collection.searchModel;
        },
        onShow: function() {
            this.showProductSearch();
        },
        showReviewPanel: function() {
            this.trigger('show:review:panel', this.source);
        },
        showProductSearch: function() {
            this.ui.backButton.css('visibility', 'hidden');
            this.showChildView('productSearchContainer', new Show.ProductSearch({
                searchModel: this.searchModel,
                collection: this.collection
            }));
        },
        doneTagging: function(_view, selectedModel) {
            this.triggerMethod('done:tagging', selectedModel);
        },
        onProductRowClicked: function(_searchView, model) {
            if (gon.current_account.uploader_product_search_mode === 'tag,product') {
                this.showChildView('productSearchContainer', new Show.ProductSearchSubcategoryPicker({
                    model: model
                }));
                this.ui.backButton.css('visibility', 'visible');
            } else {
                this.trigger('done:tagging', model);
            }
        }
    });

    Show.LoginView = App.Views.ItemView.extend({
        template: require('./templates/social_login_panel.jst.ejs'),
        id: 'panel_login',
        className: 'panel',
        events: {
            'click #login_button': 'clickLogin'
        },
        serializeData: function() {
            var _this = this;
            return {
                source: _this.options.source
            };
        },
        clickLogin: function() {
            var _this = this;
            App.execute(this.options.source + ':login:photos', function(socialLogin) {
                _this.trigger('show:social:photo:panel', socialLogin);
            });
        }
    });

    Show.FormView = App.Views.ItemView.extend({
        template: require('./templates/form_panel.jst.ejs'),
        id: 'panel_form',
        className: 'panel',
        ui: {
            fullNameInputText: '#fullname_input_text',
            clientTosCheckbox: '#client_tos_checkbox',
            emailInputText: '#email_input_text',
            dobInputText: '#dob_input_text',
            nameInput: '#name_input',
            emailInput: '#email_input',
            dobInput: '#dob_input',
            clientTosHolder: '#client_tos_holder',
            clientTosLink: '#client_tos_link a',
            additionalField: '.additional_field'
        },
        behaviors: {
            SubmitContentValidation: {}
        },
        initialize: function() {
            this.connectedUser = Show.connectedUser;
        },
        onValidationSuccess: function() {
            var keenData = {
                email: this.ui.emailInputText.val(),
                name: this.ui.fullNameInputText.val(),
                user_handle: this.model.get('instagram_user_name') || this.model.get('facebook_user_name'),
                channel: this.options.source || 'desktop'
            };
            this.trigger('keen:completed:authorization', keenData);
            this.trigger('show:next:panel');
        },
        onShow: function() {
            this.trigger('update:breadcrumb', 'four');
            // create index of focussable elements for keyboard/screen reader users
            this.trigger('get:focus:index', this.$el);
            if (this.options.source !== 'desktop') {
                this.ui.emailInputText.val(this.model.get(this.options.source + '_email_address'));
                this.ui.fullNameInputText.val(this.model.get(this.options.source + '_user_name'));
            }

            if (window._customerProvidedUserProfile) {
                if (window._customerProvidedUserProfile.name) {
                    this.ui.fullNameInputText.val(window._customerProvidedUserProfile.name);
                }
                if (window._customerProvidedUserProfile.email) {
                    this.ui.emailInputText.val(window._customerProvidedUserProfile.email);
                }
            }
        },
        onSubmit: function() {
            Show.connectedUser.set('uniqueID', gon.distinct_user_hash);
        },
        templateHelpers: {
            disableFields: function() {
                return window._customerProvidedUserProfile && window._customerProvidedUserProfile.isImmutable;
            },
            isDefaultNamePlaceholder: function() {
                return App.displayOptions.get('namePlaceholder') === I18n.translations.en.uploader.form.placeholders.fullname;
            },
            getNamePlaceholder: function() {
                return App.displayOptions.get('namePlaceholder');
            },
            isDefaultEmailPlaceholder: function() {
                return App.displayOptions.get('emailPlaceholder') === I18n.translations.en.uploader.form.placeholders.email;
            },
            getEmailPlaceholder: function() {
                return App.displayOptions.get('emailPlaceholder');
            },

            /* Renders customer-defined text boxes. */
            getExtraFields: function() {
                let fields = '';
                const additional = App.displayOptions.get('additional_fields');

                if (!_.isFalsy(additional) && additional.length > 0) {
                    const fieldRenderer = require('./templates/additional_field.jst.ejs');
                    for (let i = additional.length - 1; i >= 0; i--) {
                        fields += fieldRenderer({
                            is_public: additional[i].is_public || false,
                            is_required: additional[i].is_required || false,
                            label_text: additional[i].label_text || '',
                            placeholder_text: additional[i].placeholder_text || ''
                        });
                    }
                }
                return fields;
            },

            /* Renders customer-defined checkboxes. */
            getExtraTosFields: function() {
                var fields = '';
                const tos = App.displayOptions.get('additional_tos_fields');

                if (!_.isFalsy(tos) && tos.length > 0) {
                    const tosRenderer = require('./templates/additional_tos_field.jst.ejs');
                    for (let i = tos.length - 1; i >= 0; i--) {
                        fields += tosRenderer({
                            id: 'additional_tos_field_' + i,
                            isRequired: tos[i].isRequired || '',
                            label: tos[i].label || '',
                            link: tos[i].link || '',
                            linkText: tos[i].linkText || '',
                            labelv2: tos[i].labelv2 || ''
                        });
                    }
                }
                return _.unescape(fields);
            },
            getBrandTOSLinkText: function() {
                return App.displayOptions.get('tosLabel_text');
            },
            getBrandTOSLinkUrl: function() {
                return App.displayOptions.get('tosLink_text');
            }
        }
    });

    Show.FailedSubmissionPanel = App.Views.Layout.extend({
        template: require('./templates/failed_submission_panel.jst.ejs'),
        id: 'panel_failed_submission',
        className: 'panel',
        attributes: {
            'tabindex': '0'
        },
        ui: {
            done: '#done'
        },
        events: {
            'click @ui.done': 'closeParentIFrame'
        },
        onShow: function() {
            this.trigger('update:breadcrumb', 'hide');
        },
        closeParentIFrame: function() {
            if ('parentIFrame' in window) {
                window.parentIFrame.close();
            }
        }
    });

    Show.SocialPhotoPanelItem = App.Views.ItemView.extend({
        template: false,
        className: 'photo_item',
        attributes: {
            'tabindex': '0'
        },
        modelEvents: {
            'selected': 'selectModel'
        },
        events: {
            'click': 'clickPhoto'
        },
        onShow: function() {
            this.$el.css('background-image', 'url(' + this.model.get('picture') + ')');
        },
        selectModel: function() {
            this.$el.addClass('active');
        },
        clickPhoto: function() {
            if (this.$el.hasClass('active')) {
                this.$el.removeClass('active');
                this.model.collection.trigger('photo:unselected', this.model);
            } else {
                this.$el.addClass('active');
                this.model.collection.trigger('photo:selected', this.model);
            }
        }
    });

    Show.SocialPhotoAlbumItem = App.Views.ItemView.extend({
        template: require('./templates/social_photo_albums_panel_item.jst.ejs'),
        className: 'social_album',
        attributes: {
            'tabindex': '0'
        },
        events: {
            'click': 'clickModel'
        },
        onShow: function() {
            if (this.model.get('name') === 'Tagged Videos') {
                this.$el.addClass('album_video_tagged');
            } else if (this.model.get('name') === 'Uploaded Videos') {
                this.$el.addClass('album_video_uploaded');
            }
        },
        clickModel: function() {
            if (this.model.get('name') === 'Tagged Videos') {
                this.trigger('show:album:videos', this, {
                    model: this.model,
                    collection: this.model.collection,
                    view: this
                });
            } else if (this.model.get('name') === 'Uploaded Videos') {
                this.trigger('show:album:videos:uploaded', this, {
                    model: this.model,
                    collection: this.model.collection,
                    view: this
                });
            } else {
                this.trigger('show:album:photos', this, {
                    model: this.model,
                    collection: this.model.collection,
                    view: this
                });
            }
        }
    });

    Show.SocialPhotoAlbumPanel = App.Views.CompositeView.extend({
        template: require('./templates/social_photo_albums_panel.jst.ejs'),
        childView: Show.SocialPhotoAlbumItem,
        childViewContainer: '#fb_albums_container',
        id: 'panel_social',
        className: 'panel',
        ui: {
            loadMore: '#load_more'
        },
        triggers: {
            'click #load_more': 'load:more'
        },
        onShow: function() {
            this.trigger('update:breadcrumb', 'two');
            this.triggerMethod('loaded');
            // create a focusable element index for keyboard users
            this.trigger('get:focus:index', this.$el);
        },
        onLoaded: function() {
            if (this.options.pagination.next) {
                this.ui.loadMore.show();
            } else {
                this.ui.loadMore.hide();
            }
        }
    });

    Show.SocialPhotoPanel = App.Views.CompositeView.extend({
        template: require('./templates/social_photo_panel.jst.ejs'),
        childView: Show.SocialPhotoPanelItem,
        childViewContainer: '#social_photo_content',
        id: 'panel_social',
        className: 'panel',
        ui: {
            backAlbums: '#back_albums',
            loadMore: '#load_more',
            socialPhotoError: '#social_photo_error',
            socialPhotoEmpty: '#social_photo_empty',
            socialPhotoWrapper: '#social_photo_wrapper',
            reviewSelected: '#review_selected'
        },
        triggers: {
            'click @ui.backAlbums': 'show:album:view',
            'click @ui.loadMore': 'load:more',
        },
        events: {
            'click @ui.reviewSelected': 'reviewSelected'
        },
        collectionEvents: {
            'photo:selected': 'photoSelected',
            'photo:unselected': 'photoUnselected'
        },
        onShow: function() {
            var _this = this;
            this.trigger('update:breadcrumb', 'two');
            // create focusable element index for accessibility
            this.trigger('get:focus:index', this.$el);
            if (this.options.source === 'facebook') {
                this.ui.backAlbums.show();
            } else {
                this.ui.backAlbums.remove();
            }
            if (this.options.uploaderCollection.length > 0) {
                _.each(this.options.uploaderCollection.models, function(model) {
                    var selectedModel = _this.collection.findWhere({
                        id: model.get('id')
                    });
                    if (_.isTruthy(selectedModel)) {
                        selectedModel.trigger('selected');
                    }
                });
            }
            if (!this.collection.length) {
                this.ui.socialPhotoEmpty.show();
            }
            this.onLoaded();
        },
        photoSelected: function(model) {
            this.ui.socialPhotoError.hide();
            this.options.uploaderCollection.add(model);
            // helps determines whether alert prompt will appear for keyboard users
            Show.preventClosing.uploaderCollection = this.options.uploaderCollection.length;
        },
        photoUnselected: function(model) {
            this.options.uploaderCollection.remove(model);
            // helps determines whether alert prompt will appear for keyboard users
            Show.preventClosing.uploaderCollection = this.options.uploaderCollection.length;
        },
        reviewSelected: function() {
            if (this.options.uploaderCollection.length > 0) {
                this.trigger('show:review:panel', this.options.source);
            } else {
                this.ui.socialPhotoError.show();
                this.ui.socialPhotoError.focus();
                this.ui.socialPhotoWrapper.addClass('error_is_visible');
            }
        },
        onLoaded: function() {
            if (this.options.pagination.next) {
                this.ui.loadMore.show();
            } else {
                this.ui.loadMore.hide();
            }
        },
        onAddChild: function(view) {
            var childType = view.model.get('type');
            if (['image', 'carousel_album'].indexOf(childType) === -1) {
                view.$el.append('<div class="video_content"></div>');
            }
        }
    });

    Show.GooglePhotosItem = App.Views.ItemView.extend({
        template: false,
        className: 'photo_item',
        attributes: {
            'tabindex': '0'
        },
        modelEvents: {
            'selected': 'selectModel'
        },
        events: {
            'click': 'clickPhoto'
        },
        onShow: function() {
            this.$el.css('background-image', 'url(' + this.model.get('baseUrl') + ')');
        },
        selectModel: function() {
            this.$el.addClass('active');
        },
        clickPhoto: function() {
            if (this.$el.hasClass('active')) {
                this.$el.removeClass('active');
                this.model.collection.trigger('photo:unselected', this.model);
            } else {
                this.$el.addClass('active');
                this.model.collection.trigger('photo:selected', this.model);
            }
        }
    });

    Show.GoogleLayout = App.Views.Layout.extend({
        template: require('./templates/google_photos_layout.jst.ejs'),
        id: 'panel_google_photos',
        ui: {
            photosContainer: '#gphotos_grid_region',
            filterContainer: '#gphotos_filter_region'
        },
        regions: {
            photosRegion: '@ui.photosContainer',
            filterRegion: '@ui.filterContainer',
        },
        collectionEvents: {
            sync: 'onSync'
        },
        initialize: function(options) {
            this.uploaderCollection = options.uploaderCollection;
            this.album = options.album;
            this.loading = false;
        },
        onSync: function() {
            // hide loader
            this.ui.photosContainer.removeClass('loading');
        },
        onShow: function() {
            var photoPanel = new Show.GooglePhotosPanel({
                collection: this.collection,
                uploaderCollection: this.uploaderCollection,
                album: this.album
            });
            var filterPanel = new Show.GooglePhotosFilterPanel({
                collection: this.collection,
                uploaderCollection: this.uploaderCollection,
            });

            // show loader until photos are fetched
            this.ui.photosContainer.addClass('loading');

            this.listenTo(photoPanel, {
                // load more photos from album or that meet filter specs
                'load:more': function() {
                    this.collection.loadMore(this.album, this.collection.filter);
                },
                'focus:elements:loaded': function() {
                    // create focusable element index for accessibility
                    this.trigger('get:focus:index', this.$el);
                },
                'show:back:albums': function() {
                    /*
                     * if photos are from an album, go back to albums panel
                     * otherwise go back to source selection panel
                     */
                    if (this.album) {
                        this.trigger('show:google:albums');
                    } else {
                        this.trigger('show:google:source:selection');
                    }
                },
                'hide:error:message': function() {
                    this.ui.filterContainer.removeClass('error_is_visible');
                },
                'show:error:message': function() {
                    // add class to adjust grid and filter container heights when error is present
                    this.ui.filterContainer.addClass('error_is_visible');
                },
                'review:selected': function() {
                    this.trigger('show:review:panel', 'google');
                }
            });

            this.listenTo(filterPanel, {
                // hide error when a filter panel is opened
                'hide:error:message': function() {
                    this.ui.filterContainer.removeClass('error_is_visible');
                },
                'focus:elements:loaded': function(el) {
                    // create focusable element index for accessibility
                    this.trigger('get:focus:index', el);
                },
                'begin:filter:search': function() {
                    this.ui.photosContainer.addClass('loading');
                }
            });

            // if photos aren't from an album, show filter panel
            if (!this.album) {
                this.filterRegion.show(filterPanel);
            }
            // show photo grid
            this.photosRegion.show(photoPanel);
        }
    });

    Show.GooglePhotosFilterPanel = App.Views.ItemView.extend({
        template: require('./templates/google_photos_filter_panel.jst.ejs'),
        id: 'panel_gphotos_filter',
        ui: {
            categoryFilterSelector: '#filter_by_category',
            dateFilterSelector: '#filter_by_date',
            filterByOption: '.filter_by',
            filterRadio: '.filter_radio',
            filterCheckbox: '.filter_checkbox',
            filterAllMedia: '#filter_all_media',
            categoryCount: '.category_count',
            filterDropPanel: '#filter_drop_panel',
            categoryOptions: '#category_options',
            dateOptions: '#date_options',
            dropPanelApply: '#drop_panel_apply',
            dropPanelClose: '#drop_panel_close',
            dropPanelReset: '#drop_panel_reset',
            resetAll: '#reset_all_filters',
            dateSelector: '.date_selector',
            dateDropdown: '.date_dropdown',
            dateDropdownItem: '.date_dropdown_item',
            yearSelector: '#year_selector',
            monthSelector: '#month_selector',
            daySelector: '#day_selector',
            dayDropdown: '#day_dropdown'
        },
        events: {
            'click @ui.filterByOption': 'onShowDropPanel',
            'click @ui.filterCheckbox': 'onCategorySelection',
            'click @ui.filterRadio': 'onMediaSelection',
            'click @ui.dropPanelApply': 'onApplyFilters',
            'click @ui.dropPanelClose': 'onCloseDropPanel',
            'click @ui.dropPanelReset': 'onDropPanelReset',
            'click @ui.resetAll': 'onResetAllFilters',
            'click @ui.dateSelector': 'onDateDropdownSelector',
            'click @ui.dateDropdown': 'onDateSelection'
        },
        templateHelpers: {
            getMonths: function(index) {
                var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
                // return specific month if an index is passed as a param
                return Number.isInteger(index) ? months[index] : months;
            },
            getYears: function(index) {
                var currentYear = new Date().getFullYear();
                var years = [];
                // 2010 as base year, around the time when Google Photos was introduced to the world
                for (var i = 2010; i <= currentYear; i++) {
                    years.push(i);
                }
                // return specific year if index is passed as a param
                return Number.isInteger(index) ? years.reverse()[index] : years.reverse();
            },
            getCategoryFilters: function(index) {
                var categories = [
                    'Landscapes',
                    'Receipts',
                    'Cityscapes',
                    'Landmarks',
                    'Selfies',
                    'People',
                    'Pets',
                    'Weddings',
                    'Birthdays',
                    'Documents',
                    'Travel',
                    'Animals',
                    'Food',
                    'Sport',
                    'Night',
                    'Performances',
                    'Whiteboards',
                    'Screenshots',
                    'Utility'
                ].sort();
                // return specific category if an index is passed as a param
                return Number.isInteger(index) ? categories[index] : categories;
            }
        },
        initialize: function() {
            this.categoryCount = '0';
            this.dateLabel = '';
            // represents UI
            this.selectedCategories = [];
            this.selectedDate = this.collection.date;
            // represents data in collection
            this.submittedCategories = [];
            this.submittedDate = {};
            // bools to help determine if drop panel elements should be reset/disabled
            this.categoryFilterApplied = false;
            this.dateFilterApplied = false;
            this.mediaFilterApplied = false;
            this.disableDropPanelButtons = true;
            // tells us which panel is currently open
            this.activeFilter = 'none';
        },
        onRender: function() {
            // gets translated date string so we can reuse it when date selection
            // is reset or empty
            this.defaultDateLabel = this.ui.dateFilterSelector.text();
            // this will be the same for day, month and year so we just need to capture one value on load, in this case the Month dropdown
            this.defaultDropdownLabel = this.ui.monthSelector.text();
        },
        onShowDropPanel: function(ev) {
            // date or category
            var selector = $(ev.target);
            var filter = $(ev.target).data('filter');
            var year = this.collection.date.year;
            var month = this.collection.date.month;
            var day = this.collection.date.day;

            // activate drop panel elements
            selector.addClass('active');
            this.ui.filterDropPanel.show();
            this.activeFilter = filter;
            this.disableDropPanelButtons = false;

            switch (this.activeFilter) {
                case 'category':
                    this.ui.categoryOptions.addClass('active');
                    this.ui.dateOptions.removeClass('active');
                    this.ui.dateFilterSelector.removeClass('active').text(this.dateLabel || this.defaultDateLabel);
                    this.ui.dateDropdownItem.children('input').prop('checked', false);
                    this.ui.dateSelector.removeClass('active');
                    // select any categories that are currently applied
                    this.collection.categories.map(function(category) {
                        $('#' + category.toLowerCase()).prop('checked', true);
                    });
                    // check if panel buttons need to be disabled
                    if (!this.categoryFilterApplied) {
                        this.disableDropPanelButtons = true;
                    }
                    // if date panel was closed without clicking apply, reset it
                    if (!this.dateFilterApplied) {
                        this.resetDateDropPanel();
                    }
                    break;
                case 'date':
                    // show date filters that are currently applied
                    this.ui.dateOptions.addClass('active');
                    $('#year_' + year).prop('checked', true);
                    $('#month_' + month).prop('checked', true);
                    $('#day_' + day).prop('checked', true);
                    this.ui.yearSelector.text(year === 0 ? this.defaultDropdownLabel : year);
                    this.ui.monthSelector.text($('#month_' + month).data('month'));
                    this.ui.daySelector.text(day === 0 ? this.defaultDropdownLabel : day);
                    // deactivate categories panel
                    this.ui.categoryOptions.removeClass('active');
                    this.ui.categoryFilterSelector.removeClass('active');
                    this.ui.filterCheckbox.prop('checked', false);
                    // check if panel buttons need to be disabled
                    if (!this.dateFilterApplied) {
                        this.disableDropPanelButtons = true;
                    }
                    // if category panel was closed without clicking apply, reset it
                    if (!this.categoryFilterApplied) {
                        this.resetCategoriesDropPanel();
                    }
                    break;
                default:
                    break;
            }

            // set filter selector labels to match applied filters
            this.ui.categoryCount.text(this.collection.categories.length);
            this.ui.dateFilterSelector.text(this.formatDate(day, month, year) || this.defaultDateLabel);
            this.selectedDate = {
                year: year,
                month: month,
                day: day
            };

            // disable or enable drop panel buttons
            this.ui.dropPanelReset.prop('disabled', this.disableDropPanelButtons);
            this.ui.dropPanelApply.prop('disabled', this.disableDropPanelButtons);

            // hide warning message if drop panel is open
            this.trigger('hide:error:message');
        },
        onDateDropdownSelector: function(ev) {
            var el = $(ev.target);
            switch (el.data('date-selector')) {
                case 'year':
                    el.toggleClass('active');
                    break;
                case 'month':
                    el.toggleClass('active');
                    break;
                case 'day':
                    /*
                     * Google Photos API doesn't allow searching by day or day and year only
                     * so we need to check if a month has been selected befor enabling the day dropdown
                     */
                    if (this.selectedDate.month !== '0') {
                        el.toggleClass('active');
                    }
                    break;
                default:
                    break;
            }
        },
        onMediaSelection: function(ev) {
            var value = ev.target.value;
            this.collection.setMediaFilter(value);
            this.collection.fetchWithFilters();
            this.mediaFilterApplied = true;
            // close drop panel if a media filter is selected
            this.onCloseDropPanel();
            // activate loading icon
            this.trigger('begin:filter:search');
        },
        onCategorySelection: function() {
            var checkbox = this.ui.filterCheckbox;
            var filterArray = [];
            // collect selected categories
            for (var i = 0; i < checkbox.length; i++) {
                if (checkbox[i].checked) {
                    filterArray.push(checkbox[i].value);
                }
            }
            /*
             * Google Photos API allows up to most 10 content categories per search
             * so we need to disable other checkboxes when 10 categories have been selected
             */
            if (filterArray.length <= 10) {
                this.categoryCount = filterArray.length;
                this.ui.filterCheckbox.prop('disabled', false);
                this.ui.categoryCount.text(this.categoryCount);
                this.selectedCategories = filterArray;
                this.disableDropPanelButtons = false;
            }
            // when 10 checks are selected disable other checkmarks
            if (filterArray.length === 10) {
                this.ui.filterCheckbox.not(':checked').prop('disabled', true);
            }
            // if no checkmarks are selected, disable panel buttons
            if (_.isEmpty(filterArray)) {
                // only call API if filters are currently applied
                if (this.categoryFilterApplied) {
                    this.collection.setCategoryFilter([]);
                    this.collection.fetchWithFilters();
                    this.categoryFilterApplied = false;
                }
                this.disableDropPanelButtons = true;
                this.categoryFilterApplied = false;
            }
            // disable or enable panel buttons if valid category filters are selected
            this.ui.dropPanelReset.prop('disabled', this.disableDropPanelButtons);
            this.ui.dropPanelApply.prop('disabled', this.disableDropPanelButtons);
        },
        onDateSelection: function(ev) {
            var el = $(ev.target);
            var day = this.selectedDate.day;
            var month = this.selectedDate.month;
            var year = this.selectedDate.year;
            // search by year, month or day
            switch (el.data('date-filter')) {
                case 'year':
                    var selectedYear = parseInt(ev.target.value);
                    this.getDaysforDayDropdown(selectedYear, this.selectedDate.month);
                    this.ui.yearSelector.text(selectedYear).removeClass('active');
                    this.dateLabel = this.formatDate(day, month, selectedYear);
                    this.ui.dateFilterSelector.text(this.dateLabel);
                    this.disableDropPanelButtons = false;
                    this.selectedDate.year = selectedYear;
                    break;
                case 'month':
                    var selectedMonth = parseInt(ev.target.value);
                    this.monthName = el.data('month');
                    this.dateLabel = this.formatDate(day, selectedMonth, year);
                    this.getDaysforDayDropdown(this.selectedDate.year, selectedMonth);
                    this.ui.monthSelector.text(this.monthName).removeClass('active');
                    this.ui.dateFilterSelector.text(this.dateLabel);
                    this.disableDropPanelButtons = false;
                    this.selectedDate.month = selectedMonth;
                    break;
                case 'day':
                    var selectedDay = parseInt(ev.target.value);
                    this.dateLabel = this.formatDate(selectedDay, month, year);
                    this.ui.daySelector.text(selectedDay).removeClass('active');
                    this.ui.dateFilterSelector.text(this.dateLabel);
                    this.disableDropPanelButtons = false;
                    this.selectedDate.day = selectedDay;
                    break;
                default:
                    break;
            }
            // disable or enable panel buttons if valid date filters are selected
            this.ui.dropPanelReset.prop('disabled', this.disableDropPanelButtons);
            this.ui.dropPanelApply.prop('disabled', this.disableDropPanelButtons);
        },
        onApplyFilters: function() {
            // check which filter has been applied; category or date
            switch (this.activeFilter) {
                case 'category':
                    this.categoryFilterApplied = true;
                    this.submittedCategories = this.selectedCategories;
                    this.collection.setCategoryFilter(this.submittedCategories);
                    break;
                case 'date':
                    this.dateFilterApplied = true;
                    this.submittedDate = this.selectedDate;
                    this.collection.setYearFilter(this.submittedDate.year);
                    this.collection.setMonthFilter(this.submittedDate.month);
                    this.collection.setDayFilter(this.submittedDate.day);
                    break;
                default:
                    break;
            }
            // activate loading icon
            this.trigger('begin:filter:search');
            // call API
            this.collection.fetchWithFilters();
            // update UI
            this.disableDropPanelButtons = false;
            this.onCloseDropPanel();
        },
        onCloseDropPanel: function() {
            // check if category search has been applied
            if (!this.categoryFilterApplied) {
                this.resetCategoriesDropPanel();
            }
            // check if date search has been applied
            if (!this.dateFilterApplied) {
                this.resetDateDropPanel();
            }
            // deactivate drop panel elements
            this.ui.categoryCount.text(this.collection.categories.length);
            this.ui.dateFilterSelector.text(this.formatDate(
                this.collection.date.day,
                this.collection.date.month,
                this.collection.date.year
            ) || this.defaultDateLabel);
            this.ui.filterCheckbox.prop('checked', false);
            this.ui.filterByOption.removeClass('active');
            this.ui.categoryOptions.removeClass('active');
            this.ui.dateOptions.removeClass('active');
            this.ui.dateDropdownItem.children('input').prop('checked', false);
            this.ui.dateSelector.removeClass('active');
            this.ui.filterDropPanel.hide();
        },
        onResetAllFilters: function() {
            // reset filter values in model
            this.collection.setCategoryFilter([]);
            this.collection.setDefaultFilterValues();
            // only call API if filters are currently applied
            if (this.categoryFilterApplied || this.dateFilterApplied || this.mediaFilterApplied) {
                this.collection.fetchWithFilters();
                // activate loading icon
                this.trigger('begin:filter:search');
            }
            // reset media filter UI
            this.ui.filterAllMedia.prop('checked', true);
            // reset drop panel UI
            this.resetCategoriesDropPanel();
            this.resetDateDropPanel();
            this.ui.filterDropPanel.hide();
            this.ui.dateFilterSelector.removeClass('active');
            this.ui.categoryOptions.removeClass('active');
            this.ui.dateOptions.removeClass('active');
            this.activeFilter = 'none';
            this.categoryFilterApplied = false;
            this.dateFilterApplied = false;
            this.mediaFilterApplied = false;
        },
        onDropPanelReset: function() {
            switch (this.activeFilter) {
                case 'category':
                    // reset categories UI
                    this.resetCategoriesDropPanel();
                    // only call API if filters are currently applied
                    if (this.categoryFilterApplied) {
                        this.collection.fetchWithFilters();
                        this.ui.categoryCount.text(this.collection.categories.length);
                        // activate loading icon
                        this.trigger('begin:filter:search');
                        this.categoryFilterApplied = false;
                    }
                    break;
                case 'date':
                    // reset date UI
                    this.resetDateDropPanel();
                    // only call API if filters are currently applied
                    if (this.dateFilterApplied) {
                        this.collection.fetchWithFilters();
                        this.ui.dateFilterSelector.text(this.dateLabel || this.defaultDateLabel);
                        // activate loading icon
                        this.trigger('begin:filter:search');
                        this.dateFilterApplied = false;
                    }
                    break;
                default:
                    break;
            }
            // deactivate drop panel elements
            this.ui.filterByOption.removeClass('active');
            this.ui.categoryOptions.removeClass('active');
            this.ui.dateOptions.removeClass('active');
            this.ui.filterDropPanel.hide();
            this.activeFilter = 'none';
            // reset drop panel buttons
            this.disableDropPanelButtons = true;
        },
        resetCategoriesDropPanel: function() {
            // make sure category filter is empty
            this.collection.setCategoryFilter([]);
            // reset categories UI
            this.categoryCount = this.collection.categories.length;
            this.ui.categoryCount.text(this.categoryCount);
            this.ui.filterCheckbox.prop('checked', false);
        },
        resetDateDropPanel: function() {
            // make sure dates are defaulted
            this.collection.setDefaultDateValues();
            // reset date UI
            this.selectedDate = this.collection.date;
            this.dateLabel = '';
            this.ui.dateFilterSelector.text(this.defaultDateLabel);
            this.ui.dateSelector.removeClass('active').text(this.defaultDropdownLabel);
            this.ui.dateDropdownItem.children('input').prop('checked', false);
            this.ui.daySelector.addClass('disabled');
        },
        getDaysforDayDropdown: function(year, month) {
            // reset days to 31 in day dropdown
            this.ui.dayDropdown.children().show();

            /* enable day dropdown if a month is selected
             * but hide day options that don't exist in selected month (e.g. Feb 31)
             */
            if (month !== 0) {
                var extraDaysInMonth = new Date(year, month, 0).getDate();
                this.ui.daySelector.removeClass('disabled');
                this.ui.dayDropdown.children().slice(extraDaysInMonth).hide();
            }
        },
        formatDate: function(day, month, year) {
            var formattedDate = '';
            if (year !== 0 && month === 0) {
                // e.g. 2019
                formattedDate = year;
            } else if (month !== 0 && day !== 0 && year === 0) {
                // e.g. Feb 2
                formattedDate = $('#month_' + month).data('month').substring(0, 3) + ' ' + day;
            } else if (month !== 0 && year === 0) {
                // e.g. February
                formattedDate = $('#month_' + month).data('month');
            } else if (year !== 0 && month !== 0 && day === 0) {
                // e.g. Feb 2019
                formattedDate = $('#month_' + month).data('month').substring(0, 3) + ' ' + year;
            } else if (year !== 0 && month !== 0 && day !== 0) {
                // e.g. 08-02-19
                formattedDate = this.formatNum(day) + '-' + this.formatNum(month) + '-' + year.toString().slice(-2);
            }
            return formattedDate;
        },
        formatNum: function(num) {
            /*
             * if a number is a single digit (1-9),
             * append 0 to create a double digit (e.g. 01, 02, 03)
             */
            return num > 9 ? '' + num : '0' + num;
        },
    });

    Show.GooglePhotosPanel = App.Views.CompositeView.extend({
        template: require('./templates/google_photos_grid_panel.jst.ejs'),
        childView: Show.GooglePhotosItem,
        childViewContainer: '#gphotos_photo_content',
        id: 'panel_gphotos',
        className: 'panel',
        ui: {
            backAlbums: '#back_albums',
            loadMore: '#load_more',
            reviewSelected: '#review_selected',
            socialPhotoEmpty: '#social_photo_empty',
            socialPhotoError: '#social_photo_error',
        },
        triggers: {
            'click @ui.loadMore': 'load:more',
            'click @ui.backAlbums': 'show:back:albums',
        },
        events: {
            'click @ui.reviewSelected': 'onReviewSelected',
        },
        collectionEvents: {
            'photo:selected': 'photoSelected',
            'photo:unselected': 'photoUnselected',
            'sync': 'onSync',
        },
        initialize: function(options) {
            this.uploaderCollection = options.uploaderCollection;
            this.panel = !options.album ? 'is_library' : 'is_album';
            // adding a class adjusts the container height to accomodate filter panel
            this.$el.addClass(this.panel);
            this.loading = false;
        },
        onShow: function() {
            this.ui.loadMore.hide();
        },
        onSync: function() {
            var _this = this;

            // once photos have loaded, tell layout it can create a focus index
            this.trigger('focus:elements:loaded', this.$el);

            // if a nextPageToken is returned upon request, show load more button
            this.ui.loadMore.toggle(_.isTruthy(this.collection.nextPageToken));

            // if there are no photos, show empty error message
            this.ui.socialPhotoEmpty.toggle(!this.collection.any());

            // if user goes back to selection panel, reselect items currently in uploader queue
            if (this.uploaderCollection.any()) {
                _.each(this.uploaderCollection.models, function(model) {
                    var selectedModel = _this.collection.findWhere({
                        id: model.get('id')
                    });
                    if (_.isTruthy(selectedModel)) {
                        selectedModel.trigger('selected');
                    }
                });
            }
        },
        photoSelected: function(model) {
            this.ui.socialPhotoError.hide();
            this.uploaderCollection.add(model);
            // determines whether to show the alert box
            Show.preventClosing.uploaderCollection = this.options.uploaderCollection.length;
        },
        photoUnselected: function(model) {
            this.uploaderCollection.remove(model);
            // determines whether to show the alert box
            Show.preventClosing.uploaderCollection = this.options.uploaderCollection.length;
        },
        onReviewSelected: function() {
            if (this.uploaderCollection.any()) {
                this.trigger('review:selected', 'google');
            } else {
                this.trigger('show:error:message');
                this.ui.socialPhotoError.show();
                this.ui.socialPhotoError.focus();
            }
        }
    });

    Show.GooglePhotosAlbumItem = App.Views.ItemView.extend({
        template: require('./templates/google_photos_albums_panel_item.jst.ejs'),
        className: 'gphotos_album',
        attributes: {
            'tabindex': '0'
        },
        events: {
            'click': 'clickModel'
        },
        clickModel: function() {
            this.trigger('show:google:album:photos');
        },
    });

    Show.GooglePhotosAlbumPanel = App.Views.CompositeView.extend({
        template: require('./templates/google_photos_albums_panel.jst.ejs'),
        childView: Show.GooglePhotosAlbumItem,
        childViewContainer: '#gphotos_albums_container',
        id: 'panel_gphotos',
        className: 'panel',
        ui: {
            backAlbums: '#back_albums',
            loadMore: '#load_more',
            socialPhotoEmpty: '#social_photo_empty',
            albumsWrapper: '#gphotos_albums_wrapper'
        },
        collectionEvents: {
            'sync': 'onSync'
        },
        triggers: {
            'click @ui.backAlbums': 'show:google:source:selection'
        },
        events: {
            'click @ui.loadMore': 'onLoadMore'
        },
        onLoadMore: function() {
            this.collection.loadMore();
        },
        onShow: function() {
            // show loader
            this.ui.albumsWrapper.addClass('loading');
            this.ui.loadMore.hide();
            // create focusable element index for accessibility
            this.trigger('get:focus:index', this.$el);
        },
        onSync: function() {
            // hide loader
            this.ui.albumsWrapper.removeClass('loading');

            // nextPageToken is determined after fetch is complete, or onSync
            this.ui.loadMore.toggle(_.isTruthy(this.collection.nextPageToken));

            // check if there are no albums
            this.ui.socialPhotoEmpty.toggle(!this.collection.any());
        },
    });

    Show.GoogleSourceSelectionPanel = App.Views.ItemView.extend({
        template: require('./templates/google_photos_source_selection.jst.ejs'),
        id: 'panel_google_photos_source',
        ui: {
            googlePhotosLibrary: '#google_photos_library',
            googlePhotosAlbums: '#google_photos_albums'
        },
        triggers: {
            'click @ui.googlePhotosLibrary': 'show:google:photos',
            'click @ui.googlePhotosAlbums': 'show:google:albums'
        },
        onShow: function() {
            this.trigger('update:breadcrumb', 'two');
            // create focusable element index for accessibility
            this.trigger('get:focus:index', this.$el);
        }
    });

    Show.InfoView = App.Views.ItemView.extend({
        template: false,
        className: 'info_panel',
        attributes: {
            tabindex: '0'
        },
        events: {
            'click': 'closePanel'
        },
        onShow: function() {
            // create a focusable element index for keyboard users
            this.trigger('get:focus:index', this.$el.parent());
        },
        closePanel: function() {
            this.$el.hide();
            // reset focus index based on the main content that is now visible
            this.trigger('get:focus:index');
        }
    });
});
